export default {
  club_name: 'Piteå',
  club_name_short: 'pitea',
  stadium_name: '',
  staging_url: 'https://pitea.api.fangroup.io',
  prod_url: 'https://pitea.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/pitea',
  club_logo: '/assets/teams/pitea.png',
  app_name: 'pitea',
  websale_name: 'pitea',
  ntb_team_id: 10052,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'pitea',
  monolithEnabled: false,
};
